import { EventEmitter, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { InfluencerService } from '../../../services/influencer/influencer.service';
import { DemographicHypeAuditor, HypeAuditorGender, HAGenderDemographyByAge, HypeAuditorGenderType, HAAgeGroupItem } from '../../../../models/demographic/demographic-hype-auditor';
import { CommonConstant } from '../../../app.constants';
import { TranslateService } from '@ngx-translate/core';
import { PlaceholderVisibilityService } from '../../../services/placeholder-visibility/placeholder-visibility.service';
import { EventTrackerService, UserActionType, Page, ActivePages, TargetType } from '../../../services/event-tracker/event-tracker.service';
import { PdfExportService } from '../../../services/export-pdf/pdf-export.service';
import { UserService } from '../../../services/user.service';
import { CacheService } from '../../../services/cache/cache.service';
import { InvalidAction } from '../../../../models/user';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { Observable } from 'rxjs/Observable';
import { AchooPopupComponent } from '../../../core/achoo-popup/achoo-popup.component';
import { ModalService } from '../../../services/modal/modal.service';
import * as Sentry from '@sentry/browser';
import { StringUtils } from '../../../utils/string.utils';
import { AppSettings } from '../../../utils/app-settings';
import { ReferenceDataService } from '../../../services/reference-data/reference-data.service';
import { ObjectUtils } from '../../../utils/object.utils';
var CHART;
(function (CHART) {
    CHART[CHART["defaultPieChartHight"] = 265] = "defaultPieChartHight";
})(CHART || (CHART = {}));
export var DemographicError;
(function (DemographicError) {
    DemographicError["INVALID_LEVEL"] = "invalid_level";
    DemographicError["DATA_UNAVAILABLE"] = "data_unavailable";
    DemographicError["DATA_GENERATING"] = "data_generating";
    DemographicError["NOT_FOUND_AUDIENCE_DATA"] = "not_found_audience_data";
    DemographicError["UNSUPPORTED_PLATFORM"] = "unsupported_platform";
})(DemographicError || (DemographicError = {}));
var DemographicComponent = /** @class */ (function () {
    function DemographicComponent(route, translate, userService, placeholderService, eventTracker, influencerService, cacheService, pdfService, modalService, cdr, referenceDataService) {
        this.route = route;
        this.translate = translate;
        this.userService = userService;
        this.placeholderService = placeholderService;
        this.eventTracker = eventTracker;
        this.influencerService = influencerService;
        this.cacheService = cacheService;
        this.pdfService = pdfService;
        this.modalService = modalService;
        this.cdr = cdr;
        this.referenceDataService = referenceDataService;
        this.dataOutdatedNotificationShowingTime = 99999;
        // influencer mobile app
        this.isMobile = false;
        this.changeDemographicSourceEvent = new EventEmitter();
        this.emitSelectedDemographicSource = new EventEmitter();
        this.showDeepSocialDemographicData = false;
        this.showHypeAuditorDemographicData = false;
        this.showFallback = false;
        this.showNotificationInFallback = false;
        this.demographicSources = [];
        this.canActivateSourceSelection = false;
        this.allPlatformOpt = {
            id: 0,
            name: this.translate.instant('channel_specific.choose_account'),
        };
    }
    DemographicComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.isRedesignDemographic = AppSettings.isRedesignDemographic();
        this.countryList = this.referenceDataService.countries;
        this.languageList = this.referenceDataService.languages;
        if (!this.demoInfluencerId) {
            this.route.parent.params.subscribe(function (res) {
                _this.demoInfluencerId = res.id;
            });
        }
        if (this.selectedChannel) {
            this.selectedSource = this.selectedChannel;
        }
        else {
            this.route.queryParams.subscribe(function (params) {
                _this.target = params.target;
                _this.selectedSource = Number(params.demographicChannel);
            });
        }
        if (this.pieHeight === undefined) {
            this.pieHeight = CHART.defaultPieChartHight;
        }
        if (this.pieLegend === undefined) {
            this.pieLegend = { y: 31 };
        }
        if (this.isMobile) {
            // watching active channel change
            this.channelSubscription = this.influencerService.activeChannel.subscribe(function (channel) {
                if (channel && (!_this.selectedSource || (channel.id !== _this.selectedSource))) {
                    var selectedChannel = _this.demographicSources.find(function (s) { return s.id === channel.id; });
                    if (selectedChannel && selectedChannel.id > 0) {
                        _this.canActivateSourceSelection = false;
                        _this.onSelectDemographicSource({
                            id: selectedChannel.id,
                            platform: selectedChannel.platformName
                        });
                    }
                    else {
                        // hide everything when user select `all platform`, only show for specific channel
                        _this.selectedSource = _this.allPlatformOpt.id;
                        _this.canActivateSourceSelection = true;
                        _this.showDeepSocialDemographicData = false;
                        _this.showHypeAuditorDemographicData = false;
                        _this.showFallback = false;
                    }
                }
            });
            this.loadInfluencerChannels(this.demoInfluencerId);
        }
        else if (this.userService.isInfluencer) {
            this.loadInfluencerChannels(this.demoInfluencerId);
        }
        else {
            this.creditAvailabilitySubscription = this.influencerService.creditAvailabilityObserve.subscribe(function (res) {
                if (res === true) {
                    _this.forceUpdateUI();
                    _this.loadInfluencerChannels(_this.demoInfluencerId);
                }
                if (res === false) {
                    _this.forceUpdateUI();
                    _this.fallbackMsgTitle = _this.translate.instant('INFLUENCER.insight.fallback_title');
                    _this.fallbackMsgContent = _this.translate.instant('INFLUENCER.insight.fallback_msg', {
                        maxCredit: _this.userService.maxActiveInfluencers
                    });
                    _this.showNotificationInFallback = true;
                    _this.showFallback = true;
                    _this.sendInvalidActionToSegement({
                        wallName: 'Insights Limit',
                        maxValue: _this.userService.maxActiveInfluencers
                    });
                }
            });
        }
    };
    DemographicComponent.prototype.loadInfluencerChannels = function (influencerId) {
        var _this = this;
        this.cacheService.get("influencer_" + influencerId, this.influencerService.getInfluencer(influencerId)).subscribe(function (inf) {
            if (!inf || !inf.channels) {
                return;
            }
            var inflChannels = inf.channels.filter(function (c) { return _this.isSupportedPlatform(c.platformName.toLowerCase()); }).map(function (c) { return ({
                id: c.id,
                name: '@' + c.handle,
                platformName: c.platformName.toLowerCase(),
                platform: c.platformName.toLowerCase(),
                handle: c.handle
            }); });
            if (_this.isMobile) {
                inflChannels.unshift(_this.allPlatformOpt);
            }
            _this.demographicSources = inflChannels;
            _this.canActivateSourceSelection = _this.demographicSources.length > 0;
            var activeSource = _this.demographicSources.find(function (s) { return s.id === _this.selectedSource; });
            // default on mobile is `All platform`
            // default on desktop is first Instagram channel
            if (!activeSource) {
                activeSource = _this.isMobile ? _this.allPlatformOpt : _this.getDefaultSource(_this.demographicSources);
            }
            if (activeSource) {
                _this.onSelectDemographicSource(activeSource);
            }
            else if (!_this.isMobile) {
                _this.showFallback = true;
            }
            _this.emitSelectedDemographicSource.emit(activeSource);
        });
    };
    DemographicComponent.prototype.ngOnDestroy = function () {
        this.modalService.close();
        if (this.channelSubscription) {
            this.channelSubscription.unsubscribe();
        }
        if (this.creditAvailabilitySubscription) {
            this.creditAvailabilitySubscription.unsubscribe();
        }
        if (this.demographicSubscription) {
            this.demographicSubscription.unsubscribe();
        }
    };
    DemographicComponent.prototype.onSelectDemographicSource = function (evt) {
        var _this = this;
        if (this.isSupportedPlatform(evt.platform)) {
            this.forceUpdateUI();
            this.selectedSource = evt.id;
            this.loadDemographicData(this.demoInfluencerId, evt.id, this.userService.getCompanyId(), false);
            this.changeDemographicSourceEvent.emit(evt.id);
            this.emitSelectedDemographicSource.emit(evt);
            this.influencerService.updateActiveChannel(evt);
        }
        else {
            try {
                var parameters_1 = new URLSearchParams(window.location.href);
                // revert to previous channel if selected channel isn't supported
                if (parameters_1.get('channel')) {
                    setTimeout(function () {
                        _this.selectedSource = Number(parameters_1.get('channel'));
                    }, 20);
                }
                if (evt.id !== this.allPlatformOpt.id) {
                    this.modalService.open(this.unSupportNetworkNotification, null, true);
                }
            }
            catch (error) {
                Sentry.captureException(new Error('Error occurred while attemping to get channel from url for demographic'));
            }
        }
    };
    DemographicComponent.prototype.getDefaultSource = function (demographicSources) {
        if (demographicSources.length === 0) {
            return null;
        }
        var igSource = demographicSources.find(function (c) { return c.platform === 'instagram'; });
        return igSource ? igSource : demographicSources[0];
    };
    DemographicComponent.prototype.isSupportedPlatform = function (platform) {
        return AppSettings.getActivePlatformList().indexOf(platform) >= 0;
    };
    DemographicComponent.prototype.forceUpdateUI = function () {
        this.showDeepSocialDemographicData = false;
        this.showHypeAuditorDemographicData = false;
        this.showFallback = false;
        this.cdr.detectChanges();
    };
    DemographicComponent.prototype.loadDemographicData = function (influencerId, influencerChannelId, companyId, needToLoadDSData) {
        var _this = this;
        // don't fetch demographic data when user select `All platform` option
        if (influencerChannelId === this.allPlatformOpt.id) {
            return;
        }
        this.influencerService.checkViewDemographicPermission(companyId, influencerChannelId).subscribe(function (res) {
            // fetch demographic data
            _this.loadDemographicDataInternal(influencerId, influencerChannelId, companyId, needToLoadDSData);
            // segment track event view details group
            _this.eventTracker.trackUserAction(UserActionType.VIEW, Page.DEMOGRAPHICS, {
                id: _this.influencerService.influencerDetails.id,
                name: _this.influencerService.influencerDetails.name,
                type: TargetType.INFLUENCER
            }, undefined, undefined, {
                type: ActivePages.INFLUENCER_DEMOGRAPHICS,
                name: _this.influencerService.influencerDetails.name,
                id: _this.influencerService.influencerDetails.id
            });
        }, function (err) {
            if (err.error && err.error.data === 'invalid_level') {
                _this.userService.doInvalidActionByLevel('View Demographic', err.error.message);
                _this.sendInvalidActionToSegement({
                    wallName: 'Insights Limit',
                    maxValue: _this.userService.maxActiveInfluencers
                });
            }
            _this.hideLoader();
            _this.showFallback = true;
        });
    };
    DemographicComponent.prototype.loadDemographicDataInternal = function (influencerId, influencerChannelId, companyId, needToLoadDSData) {
        var _this = this;
        this.errorCode = null;
        var demographicRequests = [
            this.influencerService.loadInfluencEyeData(influencerChannelId, companyId).catch(function (error) {
                _this.handleDemographicError(error);
                return Observable.of(null);
            })
        ];
        if (needToLoadDSData) {
            demographicRequests.push(this.influencerService.getInstagramAudienceData(influencerId).catch(function (error) {
                _this.errorCode = DemographicError.NOT_FOUND_AUDIENCE_DATA;
                return Observable.of(null);
            }).map(function (ia) { return ia ? ia.audienceData : null; }));
        }
        this.executeDemographicRequests(demographicRequests, influencerChannelId, needToLoadDSData);
    };
    DemographicComponent.prototype.executeDemographicRequests = function (demographicRequests, influencerChannelId, needToLoadDSData) {
        var _this = this;
        var demographicObserver = forkJoin.apply(void 0, demographicRequests);
        if (!this.cacheService.has("demographic_data_" + influencerChannelId)) {
            this.showLoader();
        }
        this.demographicSubscription = this.cacheService.get("demographic_data_" + influencerChannelId, demographicObserver)
            .subscribe(function (res) {
            _this.handleDemographicResponse(res, needToLoadDSData);
            _this.userService.triggerUpdateActivatedInfluencers();
            // don't cache data if error
            if (_this.errorCode) {
                _this.cacheService.clear("demographic_data_" + influencerChannelId);
            }
        });
    };
    DemographicComponent.prototype.handleDemographicResponse = function (res, needToLoadDSData) {
        this.hideLoader();
        // only get top 10 audienceInterest
        this.hypeAuditorData = res[0] ? Object.assign({}, res[0], {
            audienceInterest: res[0].audienceInterest && res[0].audienceInterest.length > 10 ? res[0].audienceInterest.slice(0, 10) : res[0].audienceInterest
        }) : null;
        if (needToLoadDSData) {
            this.deepSocialData = this.isRedesignDemographic ? this.convertDeepSocialDataToHypeAuditorData(res[1]) : res[1];
        }
        // if missing IE data but DS data is available, mark influencer as visited
        if (!this.hypeAuditorData && this.deepSocialData) {
            this.influencerService.visitInfluencer(this.demoInfluencerId, this.userService.getCompanyId()).subscribe();
        }
        this.showDemographicData();
    };
    DemographicComponent.prototype.handleDemographicError = function (error) {
        if (!error || !error.error || !error.error.data) {
            this.fallbackMsgTitle = this.translate.instant('demographic_fallback.unexpected_error_title');
            this.fallbackMsgContent = this.translate.instant('demographic_fallback.unexpected_error_msg');
        }
        else if (error.error.data === 'invalid_level') {
            this.errorCode = DemographicError.INVALID_LEVEL;
            this.userService.doInvalidActionByLevel('Add to Campaign', this.translate.instant('common.invalid_action_by_levels_warning.influencer_profile.demographic_credit_exceed', {
                maxCredit: this.userService.maxActiveInfluencers
            }));
        }
        else if (error.error.data === 'data_unavailable') {
            this.errorCode = DemographicError.DATA_UNAVAILABLE;
            this.fallbackMsgTitle = this.translate.instant('demographic_fallback.audience_data_unavailable');
            this.fallbackMsgContent = error.error.message; // TODO: Never show messages from the WS, it can't be localised to user languages.
        }
        else if (error.error.data === 'data_generating') {
            this.errorCode = DemographicError.DATA_GENERATING;
            this.fallbackMsgTitle = this.translate.instant('demographic_fallback.audience_data_generating');
            this.fallbackMsgContent = this.translate.instant('demographic_fallback.audience_data_generating_msg');
        }
        else if (error.error.data === 'not_found_audience_data') {
            this.errorCode = DemographicError.NOT_FOUND_AUDIENCE_DATA;
            this.handleNotFoundInfluencerError();
        }
        else if (error.error.data === 'unsupported_platform') {
            this.errorCode = DemographicError.UNSUPPORTED_PLATFORM;
            this.fallbackMsgTitle = this.translate.instant('demographic_fallback.no_data_message_header');
            this.fallbackMsgContent = this.translate.instant('demographic_fallback.no_data_message_detail');
            this.modalService.close();
            this.modalService.open(this.unsupportedPlatformNotification, null, true);
        }
        else {
            this.fallbackMsgTitle = this.translate.instant('demographic_fallback.unexpected_error_title');
            this.fallbackMsgContent = this.translate.instant('demographic_fallback.unexpected_error_msg');
        }
    };
    DemographicComponent.prototype.handleNotFoundInfluencerError = function () {
        var _this = this;
        this.fallbackMsgTitle = this.translate.instant('demographic_fallback.audience_data_not_found');
        var activeSource = this.demographicSources.find(function (s) { return s.id === _this.selectedSource; });
        this.fallbackMsgContent = this.translate.instant('demographic_fallback.audience_data_not_found_msg', {
            network: activeSource ? StringUtils.capitalize(activeSource.platformName) : ''
        });
    };
    DemographicComponent.prototype.showDemographicData = function () {
        if (this.target === 'discover') {
            if (this.canShowDSData()) {
                this.showDeepSocial();
            }
            else if (this.hypeAuditorData) {
                this.showHAData();
            }
            else if (!this.pdfService.exportingPdf && this.errorCode === DemographicError.DATA_GENERATING) {
                // don't show fallback view on pdf report
                this.showFallback = true;
            }
        }
        else {
            if (this.hypeAuditorData) {
                this.showHAData();
            }
            else if (this.canShowDSData()) {
                this.showDeepSocial();
            }
            else {
                if (this.pdfService.exportingPdf) {
                    return;
                }
                this.handleError();
            }
        }
    };
    DemographicComponent.prototype.handleError = function () {
        if (this.errorCode === DemographicError.NOT_FOUND_AUDIENCE_DATA) {
            this.handleNotFoundInfluencerError();
        }
        this.showDeepSocialDemographicData = false;
        this.showFallback = true;
        this.cdr.detectChanges();
    };
    DemographicComponent.prototype.canShowDSData = function () {
        var _this = this;
        var activeSource = this.demographicSources.find(function (s) { return s.id === _this.selectedSource; });
        return activeSource && activeSource.platformName === 'instagram' && this.deepSocialData;
    };
    DemographicComponent.prototype.sendInvalidActionToSegement = function (limitInfo) {
        var detailAction = new InvalidAction(true, limitInfo.blockedReason, limitInfo.wallType, limitInfo.wallName, true, limitInfo.maxValue, limitInfo.desiredValue, this.userService.currentUserLevel.name);
        this.eventTracker.trackUserInvalidAction(detailAction, UserActionType.VIEW, Page.DEMOGRAPHICS, {
            id: this.influencerService.influencerDetails.id,
            name: this.influencerService.influencerDetails.name,
            type: TargetType.INFLUENCER
        });
    };
    DemographicComponent.prototype.showDeepSocial = function () {
        var _this = this;
        this.showHypeAuditorDemographicData = false;
        var activeSource = this.demographicSources.find(function (s) { return s.id === _this.selectedSource; });
        if (activeSource && activeSource.platformName === 'instagram' && this.deepSocialData) {
            this.showDeepSocialDemographicData = true;
            this.showFallback = false;
            if ((this.hypeAuditorData || this.errorCode !== DemographicError.NOT_FOUND_AUDIENCE_DATA) && !this.pdfService.exportingPdf) {
                this.modalService.open(this.dataOutdatedNotification, null, true, this.dataOutdatedNotificationShowingTime);
            }
        }
        else {
            this.showDeepSocialDemographicData = false;
            this.showFallback = true;
        }
        this.cdr.detectChanges();
    };
    DemographicComponent.prototype.showHAData = function () {
        this.showDeepSocialDemographicData = false;
        if (this.hypeAuditorData) {
            this.showHypeAuditorDemographicData = true;
            this.showFallback = false;
            if (this.hypeAuditorData.isOutdated && !this.pdfService.exportingPdf) {
                this.modalService.open(this.dataOutdatedNotification, null, true, this.dataOutdatedNotificationShowingTime);
            }
            if (this.hypeAuditorData.isNew) {
                this.influencerService.markPreloadedInfluencerOutdated(this.demoInfluencerId);
                this.hypeAuditorData.isNew = false;
            }
        }
        else {
            this.showHypeAuditorDemographicData = false;
            this.showFallback = true;
        }
        this.cdr.detectChanges();
    };
    DemographicComponent.prototype.showFallbackView = function () {
        this.showHypeAuditorDemographicData = false;
        this.showDeepSocialDemographicData = false;
        this.showFallback = true;
    };
    DemographicComponent.prototype.openHypeAuditor = function () {
        this.target = null;
        this.modalService.close();
        if (this.hypeAuditorData && this.hypeAuditorData.isOutdated) {
            this.updateInfluencerDemographic(this.selectedSource, this.userService.getCompanyId());
        }
        else {
            this.showHAData();
        }
    };
    DemographicComponent.prototype.updateInfluencerDemographic = function (channelId, companyId) {
        var _this = this;
        this.showLoader();
        // clear cache of old data
        this.cacheService.clear("demographic_data_" + channelId);
        this.influencerService.updateInfluencerDemographic(channelId, companyId).subscribe(function (res) {
            _this.hypeAuditorData = res;
            _this.hideLoader();
            _this.showHAData();
            _this.userService.triggerUpdateActivatedInfluencers();
        }, function (error) {
            _this.handleDemographicError(error);
            _this.hideLoader();
            _this.showFallbackView();
        });
    };
    DemographicComponent.prototype.closeNotification = function () {
        this.modalService.close();
    };
    Object.defineProperty(DemographicComponent.prototype, "isExportingPdfReport", {
        get: function () {
            return this.pdfService.exportingPdf;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DemographicComponent.prototype, "showDemographicSourceSelection", {
        get: function () {
            return this.canActivateSourceSelection && !this.pdfService.exportingPdf;
        },
        enumerable: true,
        configurable: true
    });
    DemographicComponent.prototype.convertDeepSocialDataToHypeAuditorData = function (deepSocialData) {
        // no deep social data. Stop immediately
        if (!deepSocialData) {
            return;
        }
        var convertedHypeAuditorData = new DemographicHypeAuditor();
        var rawChartData;
        rawChartData = {
            content_persons_statistic: ObjectUtils.parseJSON(deepSocialData.content_persons_statistic),
            content_geo_statistic: ObjectUtils.parseJSON(deepSocialData.content_geo_statistic),
            audience_interests: ObjectUtils.parseJSON(deepSocialData.audience_interests),
            audience_languages: ObjectUtils.parseJSON(deepSocialData.audience_languages)
        };
        if (rawChartData.content_persons_statistic) {
            convertedHypeAuditorData.genders = this.convertAudienceGender(rawChartData.content_persons_statistic.genders);
            convertedHypeAuditorData.demographyByAge = this.convertGenderPerAgeFromDSToHA(rawChartData.content_persons_statistic.gendersPerAge, rawChartData.content_persons_statistic.genders);
        }
        if (rawChartData.content_geo_statistic) {
            convertedHypeAuditorData.countries = this.calculateTopItem(this.convertAudienceCountries(rawChartData.content_geo_statistic.countries));
            convertedHypeAuditorData.cities = this.convertAudienceCities(rawChartData.content_geo_statistic.cities);
        }
        if (rawChartData.audience_interests) {
            convertedHypeAuditorData.audienceInterest = this.calculateTopItem(this.convertAudienceInterest(rawChartData.audience_interests));
        }
        if (rawChartData.audience_languages) {
            convertedHypeAuditorData.languages = this.calculateTopItem(this.convertAudienceLanguages(rawChartData.audience_languages));
        }
        return convertedHypeAuditorData;
    };
    DemographicComponent.prototype.convertGenderPerAgeFromDSToHA = function (genderPerAges, genders) {
        var femalePerAge = new HAGenderDemographyByAge();
        femalePerAge.gender = 'FEMALE';
        femalePerAge.value = Math.round(genders['FEMALE'] * 100);
        femalePerAge.by_age_group = Object.keys(genderPerAges).map(function (age) {
            var ageGroup = new HAAgeGroupItem();
            ageGroup.group = age;
            ageGroup.value = Math.round(genderPerAges[age].FEMALE * 100);
            return ageGroup;
        });
        var malePerAge = new HAGenderDemographyByAge();
        malePerAge.gender = 'MALE';
        malePerAge.value = Math.round(genders['MALE'] * 100);
        malePerAge.by_age_group = Object.keys(genderPerAges).map(function (age) {
            var ageGroup = new HAAgeGroupItem();
            ageGroup.group = age;
            ageGroup.value = Math.round(genderPerAges[age].MALE * 100);
            return ageGroup;
        });
        return [femalePerAge, malePerAge];
    };
    DemographicComponent.prototype.convertAudienceGender = function (genders) {
        var female = new HypeAuditorGender();
        female.gender = HypeAuditorGenderType.FEMALE;
        female.value = Math.round(genders['FEMALE'] * 100);
        var male = new HypeAuditorGender();
        male.gender = HypeAuditorGenderType.MALE;
        male.value = Math.round(genders['MALE'] * 100);
        return [male, female];
    };
    DemographicComponent.prototype.convertAudienceInterest = function (audience_interests) {
        return Object.keys(audience_interests).map(function (key) {
            var audienceInterest = [key, audience_interests[key]];
            return audienceInterest;
        });
    };
    DemographicComponent.prototype.convertAudienceCountries = function (countries) {
        var result = Object.keys(countries).map(function (key) { return ({ name: key, value: Math.round(countries[key] * 100) }); });
        result = this.convertCodeConstanst(result, this.countryList);
        return result;
    };
    DemographicComponent.prototype.convertAudienceCities = function (cities) {
        var mappedData = [];
        cities.forEach(function (item) {
            mappedData.push({ name: item.name, value: Math.round(item.percentage * 100) });
        });
        return mappedData;
    };
    DemographicComponent.prototype.convertAudienceLanguages = function (languages) {
        var result = Object.keys(languages).map(function (key) { return ({ code: key, value: Math.round(languages[key] * 100) }); });
        return result;
    };
    /**
    * convert code to name (language, country,...) by using code
    * @param data, constants
    */
    DemographicComponent.prototype.convertCodeConstanst = function (data, constants) {
        // create hash map constanst
        var constantsHash = constants.reduce(function (map, obj) { return (map[obj.code] = obj.name, map); }, {});
        // Assign data point code to get name from contanst hash
        var transformedData = data.map(function (item) { return Object.assign(item, {
            name: constantsHash[item.name]
        }); });
        return transformedData;
    };
    /**
   * calculate Top 10 Items for pie chart
   * @param data
   */
    DemographicComponent.prototype.calculateTopItem = function (data) {
        // Get max 10 items
        var selectedItems = data.slice(0, CommonConstant.PIE_CHART_TOP_ITEM);
        // Get the sum of percentage for selected items
        var totalPercent = selectedItems.reduce(function (accumulator, value) { return accumulator + value.y; }, 0);
        // Recalculate item percentages to be proportional to the sum of the top 10 items
        var calculatedItems = selectedItems.map(function (item) { return Object.assign(item, { y: (item.y * (100 / (totalPercent * 100))) }); });
        return calculatedItems;
    };
    DemographicComponent.prototype.showLoader = function () {
        var _this = this;
        this.loaderTimeout = setTimeout(function () {
            _this.showDeepSocialDemographicData = false;
            _this.showHypeAuditorDemographicData = false;
            _this.showFallback = false;
            _this.placeholderService.show(CommonConstant.DEMOGRAPHIC_PLACEHOLDER);
        }, 500);
    };
    DemographicComponent.prototype.hideLoader = function () {
        clearTimeout(this.loaderTimeout);
        this.placeholderService.hide(CommonConstant.DEMOGRAPHIC_PLACEHOLDER);
    };
    return DemographicComponent;
}());
export { DemographicComponent };



// WEBPACK FOOTER //
// ./src/app/main/influencer/demographic/demographic.component.ts.pre-build-optimizer.js